<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "App",
  created() {
    this.$store.dispatch("setMobsEnviroment");
  },
  computed: {
    searchParam(){
      return window.location.search
    }
  },
  methods: {
    ...mapActions({
      signWithLink: 'autologin'
    }),
  },

  watch: {
    "searchParam":{
    async handler(newValue) {
      if (newValue == null || newValue === "") return
      await this.signWithLink(newValue)
    },
    immediate: true
  }
}
};
</script>

<style>
.v-application--wrap {
  min-height: auto !important;
}
</style>